import {slider_additional_products} from '../components/slick-carousel';

export default {
  init() {
    slider_additional_products();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js